module.exports = __webpack_public_path__ + "static/scale-model-of-circle-of-lights-in-indianapolis-indiana-c6898bef0a33308dd0754e6297b09f53.png";